"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _localStorage = require("../../utils/localStorage");

var _types = require("./types");

var _types2 = require("../locations/types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var KEY_LOGGED_IN = "loggedIn";
var KEY_CLAIMS = "claims";
var KEY_EMAIL = "authEmail";
var KEY_ORG_IDS = "orgIdz";
var KEY_REMAINING_SEARCHES = "remainingSearches";
var INITIAL_STATE = {
  authEmail: (0, _localStorage.getLocal)(KEY_EMAIL),
  loggedIn: (0, _localStorage.getLocal)(KEY_LOGGED_IN, false) === "true" || false,
  // read from disk
  claims: (0, _localStorage.getLocal)(KEY_CLAIMS, true) || {},
  orgIds: (0, _localStorage.getLocal)(KEY_ORG_IDS, true) || [],
  loggingIn: false,
  userIP: null,
  showRateLimitMessage: false,
  showBlacklistMessage: false,
  initialBlacklistMessage: false,
  countryBlocked: false,
  isBlacklisted: false,
  remainingSearches: (0, _localStorage.getLocal)(KEY_REMAINING_SEARCHES)
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var orgIds = null;

  switch (action.type) {
    case _types.USER_AUTHED:
      (0, _localStorage.saveLocal)(KEY_CLAIMS, action.payload, true);
      (0, _localStorage.saveLocal)(KEY_LOGGED_IN, true, false);
      orgIds = action.payload.orgIds || [];
      (0, _localStorage.saveLocal)(KEY_ORG_IDS, orgIds, true);
      return _objectSpread(_objectSpread({}, state), {}, {
        loggedIn: true,
        claims: action.payload,
        orgIds: orgIds,
        loggingIn: false
      });

    case _types.USER_UNAUTHED:
      (0, _localStorage.saveLocal)(KEY_CLAIMS, {}, true);
      (0, _localStorage.saveLocal)(KEY_LOGGED_IN, false, false);
      return _objectSpread(_objectSpread({}, state), {}, {
        loggedIn: false,
        claims: {}
      });

    case _types.EMAIL_LINK_INIT:
      (0, _localStorage.saveLocal)(KEY_EMAIL, action.payload);
      return _objectSpread(_objectSpread({}, state), {}, {
        authEmail: action.payload
      });

    case _types.LOGGING_IN:
      return _objectSpread(_objectSpread({}, state), {}, {
        loggingIn: true
      });

    case _types.USER_IP_SUCCESS:
      (0, _localStorage.saveLocal)(KEY_REMAINING_SEARCHES, action.payload.remainingSearches);
      return _objectSpread(_objectSpread({}, state), {}, {
        userIP: action.payload.userIP,
        remainingSearches: action.payload.remainingSearches,
        isBlacklisted: action.payload.isBlacklisted,
        blockCountry: action.payload.blockCountry
      });

    case _types2.LOCATIONS_SUCCESS:
      (0, _localStorage.saveLocal)(KEY_REMAINING_SEARCHES, state.remainingSearches - 1);
      return _objectSpread(_objectSpread({}, state), {}, {
        remainingSearches: state.remainingSearches - 1
      });

    case _types.TOGGLE_RATE_LIMIT_MESSAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        showRateLimitMessage: !state.showRateLimitMessage
      });

    case _types.TOGGLE_BLACK_LIST_MESSAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        isBlacklisted: true,
        showRateLimitMessage: false,
        initialBlacklistMessage: action.payload
      });

    default:
      return state;
  }
};

exports.default = _default;